import { structApi } from '@deepup/internal-apis';

type ListValue = structApi.ListValue;
type Value = structApi.Value;

export type Point3 = [number, number, number];

const numberOrZero = (value: Value | undefined): number =>
  value?.kind.oneofKind === 'numberValue' ? value.kind.numberValue : 0;

export const convertListValueToPoint = (lv: ListValue | undefined): Point3 | null => {
  if (!lv || lv.values.length < 2) return null;
  return [numberOrZero(lv.values[0]), numberOrZero(lv.values[1]), numberOrZero(lv.values[2])];
};

export const convertListValueToCoordinates = (lv: ListValue | undefined): Point3[] => {
  if (!lv) return [];
  return lv.values
    .map((v) =>
      v.kind.oneofKind === 'listValue' ? convertListValueToPoint(v.kind.listValue) : null,
    )
    .filter((p): p is Point3 => p !== null);
};
